export const percentStringToBasisPoints = (percent: string): number =>
    Math.round((parseFloat(percent || "0") || 0) * 100);
